import { useVerbiageQuery } from "@repo/baseCloud";
import { keyPair } from "@repo/models";
import { DropDownList, FiltersV2, TextBox } from "@repo/ui";
import { FC } from "react";

import { useAssociationsInfoContext } from "../../../contexts/editableItemContext";
import { AssociationFilters } from "../../../models";
import styles from "./style.module.scss";

export const Filters: FC = () => {
	const { associations, saving, filters, setFilters } = useAssociationsInfoContext();
	const { office } = useVerbiageQuery().verbiage;

	const marketers = associations
		.map((a) => ({ id: a.marketerId, value: a.marketerName }) as keyPair<string>)
		.sort((a, b) => a.value.localeCompare(b.value));

	// Runs on every keystroke in Search, so dedupe in one pass (it used to copy the list once per branch)
	const statesById = new Map<number, keyPair<string>>();
	for (const a of associations)
		for (const b of a.branches) statesById.set(b.branchStateId, { id: b.branchStateId, value: b.branchStateName });
	const states = [...statesById.values()].sort((a, b) => a.value.localeCompare(b.value));

	const filterChanged = (name: keyof AssociationFilters, value: any) => {
		setFilters({ ...filters, [name]: value });
	};

	return (
		<FiltersV2 className={styles.filterContainer}>
			<TextBox
				label="Search"
				id="name"
				value={filters.name}
				disabled={saving}
				placeholder="Contains"
				changeHandler={(v) => filterChanged("name", v)}
				className={styles.filterField}
			/>
			<DropDownList
				label="Vendor"
				id="marketerId"
				values={marketers}
				value={filters.marketerId}
				textProp="value"
				valueProp="id"
				disabled={saving}
				changeHandler={(v) => filterChanged("marketerId", v)}
				className={styles.filterField}
				clearable
			/>
			<DropDownList
				label={`${office} State`}
				id="stateId"
				values={states}
				value={filters.stateId}
				textProp="value"
				valueProp="id"
				disabled={saving}
				changeHandler={(v) => filterChanged("stateId", v)}
				className={styles.filterField}
				clearable
			/>
		</FiltersV2>
	);
};
